import $ from "jquery";
import { EMPTY } from "../constants/global";
import selectSingleElement from "../dom/selectSingleElement";

function onRemove(e: MouseEvent) {
	e.preventDefault();
	const outlineInput = selectSingleElement<HTMLInputElement>(".pplr-text.pplr-outline .pplr_text");
	if (outlineInput) outlineInput.value = EMPTY;

	$(".pplr-outline .pplr-swatch-element.selected").removeClass("selected");
	$(".pplr-create-a-one-of-a-kind-hat .pplr-swatch-element.selected").trigger("click");
	const outlineCanvasWrapper = document.getElementById("outline-canvas-wrapper") as HTMLElement;
	outlineCanvasWrapper?.remove();
}

export default onRemove;
